import React from 'react';
export function Footer() {
  return <footer className="bg-[#10284D] px-4 py-12 text-center text-sm text-white/60" data-id="element-70" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-71" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-72" data-mp="3gh3n22klrk9c">∑ MATH READY</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-73" data-mp="32lrmvfnoh1l1">
          A complete, ready-to-teach math curriculum for teachers, tutors, homeschoolers, and families worldwide.
        </p>
        <nav aria-label="Legal" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-74" data-mp="3ud7gvurkdqla">
          <a href="#terms" className="transition-colors hover:text-white" data-id="element-75" data-mp="36d08okdmdj3">
            Terms &amp; Conditions
          </a>
          <a href="#privacy" className="transition-colors hover:text-white" data-id="element-76" data-mp="3qcxa4fvy6w5d">
            Privacy Policy
          </a>
          <a href="#contact" className="transition-colors hover:text-white" data-id="element-77" data-mp="29y5hc1uw3mvj">
            Contact
          </a>
        </nav>
        <p data-id="element-78" data-mp="2ezurzge79yj3">© 2026 Math Ready — All rights reserved.</p>
      </div>
    </footer>;
}